// src/config.js
// 診所預約系統配置檔案 - 已移除 AWS 直接存取配置，改用安全的 Lambda API

export const config = {
  // backend/ 的 SAM stack 輸出 ApiUrl（部署後填入）
  apiBaseUrl: "https://vbyqc8xig0.execute-api.ap-northeast-1.amazonaws.com",
  // 以下排班設定需與 backend/src/lib/schedule.mjs 一致（後端以那邊為準）
  numberOfWeeks: 17, // 病人可預約的未來週數
  numberOfLeaveWeeks: 25, // 請假系統可操作的週數
  numberOfPastWeeks: 4, // admin 可瀏覽的過去週數
  managementPastDays: 7, // management 日期選單可往前選的天數
  daysOfWeek: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
  localStorageTimeout: 360, // 360 minutes
  debug: () => {
    const currentUrl = window.location.href;
    if (currentUrl.includes("master")) {
      return false;
    }
    // dev 環境下，切換到正式 DB 時也視為非 debug 模式
    if (localStorage.getItem("reportUseProductionDb") === "true") {
      return false;
    }
    return true;
  },
  getUTC8Time: () => {
    // 獲取當前時間
    const now = new Date();

    // 獲取當前時間的 UTC 時間
    const utcTime = now.getTime() + now.getTimezoneOffset() * 60000;

    // 計算 UTC+8 的時間
    const utc8Time = new Date(utcTime + 8 * 60 * 60000);

    return utc8Time;
  },
  gettodayymd: () => {
    const formatter = new Intl.DateTimeFormat("zh-TW", {
      timeZone: "Asia/Taipei",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const parts = formatter.formatToParts(new Date());
    const year = parts.find((part) => part.type === "year")?.value;
    const month = parts.find((part) => part.type === "month")?.value;
    const day = parts.find((part) => part.type === "day")?.value;
    return `${year}-${month}-${day}`;
  },
  getWeekdayFromYmd: (ymd) => {
    const [year, month, day] = String(ymd).split("-").map(Number);
    if (!year || !month || !day) {
      return config.daysOfWeek[0];
    }
    const weekday = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
    return config.daysOfWeek[weekday];
  },
  getTaipeiTimeString: async () => {
    // 取得現在的時間 2023-05-01-15-30-45
    const now = new Date();

    // 設定台北時區
    const options = {
      timeZone: "Asia/Taipei",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };

    // 使用 Intl.DateTimeFormat 格式化時間
    const formatter = new Intl.DateTimeFormat("zh-TW", options);
    const parts = formatter.formatToParts(now);

    // 將格式化的時間轉換為指定的字串格式
    const dateTimeString = `${parts[0].value}-${parts[2].value}-${parts[4].value}-${parts[6].value}-${parts[8].value}-${parts[10].value}`;

    return dateTimeString;
  },
  feeTable: {
    listlingFee: { hansheng: 31250, yoyo: 12500 },
    clinicCount: { clinic: 0, doctor: 5000 },
    totalArrived: { clinic: 250, doctor: 0 },
    totalFirstDoctorInfo: { clinic: 500, doctor: 100 },
    totalNotFirstDoctorInfo: { clinic: 300, doctor: 100 },
    totalBoneAge: { clinic: 1000, doctor: 400 },
    totalDaflon: { clinic: 6479, doctor: 1350 },
    totalDaflon4W: { clinic: 1855, doctor: 450 },
    totalLeuplin12W: { clinic: 4717, doctor: 1250 },
    totalGrowthHormone: { clinic: 3356, doctor: 850 },
    totalOmnitrop: { clinic: 3600, doctor: 690 },
    totalSogroya_clinic: { clinic: 11300, doctor: 2250 },
    totalSogroya_home: { clinic: 10300, doctor: 2150 },
    totalUltrasoundForPelvis: { clinic: 1000, doctor: 400 },
    totalBloodTestType: {
      PPG: { clinic: 450, doctor: 90 },
      PPB1: { clinic: 750, doctor: 150 },
      PPB: { clinic: 450, doctor: 90 },
      SHOR1: { clinic: 1750, doctor: 350 },
      SHOR2G: { clinic: 1750, doctor: 350 },
      SHOR2B: { clinic: 1750, doctor: 350 },
      OBES1: { clinic: 950, doctor: 130 },
      OBES2: { clinic: 950, doctor: 130 },
      OBES3: { clinic: 150, doctor: 30 },
      GH1: { clinic: 350, doctor: 70 },
      GH2: { clinic: 450, doctor: 90 },
      GH3: { clinic: 600, doctor: 120 },
      PROL: { clinic: 150, doctor: 30 },
      THY1: { clinic: 250, doctor: 50 },
      THY2: { clinic: 1100, doctor: 220 },
    },
  },
  EnglishToChinese: {
    listlingFee: "掛牌費",
    clinicCount: "門診數",
    arrived: "到診",
    first: "初診",
    notFirst: "複診",
    boneAge: "骨齡",
    daflon: "達菲林",
    growthHormone: "生長激素",
    omnitrop: "歐密拓",
    sogroya_clinic: "諾和高(診所)",
    sogroya_home: "諾和高(自宅)",
    ultrasoundForPelvis: "盆腔超聲",
    bloodTest: "血液檢查",
    bloodTestType: "血液檢查",
    doctorInfo: "醫生問診",
    firstDoctorInfo: "初診問診",
    notFirstDoctorInfo: "複診問診",
  },
};
